import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Person } from '../../interfaces/persons.interface';
import { PersonsService } from '../../services/persons.service';
import { Card } from '../../interfaces/cards.interface';

@Component({
  selector: 'app-card',
  standalone: false,
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  card: Card | null = null;
  message = '';
  qrWidth = 200;

  constructor(private personService: PersonsService) { }

  ngOnInit(): void {
    this.setQrWidth();
    window.addEventListener('resize', () => this.setQrWidth());

    const cachedCard = localStorage.getItem('userCard');
    if (cachedCard) {
      this.card = JSON.parse(cachedCard);

    }

    if (navigator.onLine && !this.card) {
      this.personService.getCurrent().subscribe({
        next: (persons: Person[]) => {
          // Find the first person with an active card or use the first person
          const person = persons.find(p => 
            p.cards && 
            (p.parent_id == 0 || p.parent_id === null) &&
            p.cards.length > 0 && 
            [2, 3, 4].includes(p.cards[0].status)
          ) || persons[0];

          if (
            person &&
            person.cards &&
            person.cards.length > 0 &&
            [2, 3, 4].includes(person.cards[0].status) 
          ) {
            
            this.card = person.cards.find(c => c.person.parent_id == 0 || c.person.parent_id === null) || person.cards[0] || null;

            if (person.parent_id == 0 || person.parent_id === null) {
              this.card.children = person.children;
            }

            localStorage.setItem('userCard', JSON.stringify(this.card));
            this.card.code = `${this.card.code}`; // Ensure code is a string
          } else {
            this.message = 'Brak aktywnej karty użytkownika';
            //localStorage.removeItem('userCard');
          }
        },
        error: () => {
          this.message = 'Błąd podczas pobierania danych użytkownika';
        }
      });
    }
  }

  setQrWidth() {
    // Set QR width to 90% of container or max 460px
    this.qrWidth = Math.min(window.innerWidth - 50, 350);
  }
}